// extracted by css-extract-rspack-plugin
export default {"container":"JoinedStatusSelectBoxes__container--IvjqA","field":"JoinedStatusSelectBoxes__field--vHsCj","fieldLabel":"JoinedStatusSelectBoxes__fieldLabel--gqinO"};